module.exports = __webpack_public_path__ + "resources/img/img_intermax_3_m.b80c43fd3d930181fd70ce1f9e1354d4.png";